import React from 'react';
import Icon from '@/components/ui/AppIcon';

const courses = [
  { id: 'course-001', title: 'Product Mastery: Wellness', progress: 85, total: 12, completed: 10, color: 'bg-emerald-500' },
  { id: 'course-002', title: 'Social Media for Members', progress: 60, total: 8, completed: 5, color: 'bg-blue-500' },
  { id: 'course-003', title: 'Building Your Customer Base', progress: 33, total: 6, completed: 2, color: 'bg-violet-500' },
];

export default function AcademyProgress() {
  return (
    <div className="card-elevated rounded-xl overflow-hidden">
      <div className="flex items-center justify-between p-4 border-b border-border">
        <h3 className="text-sm font-semibold text-foreground">Academy Progress</h3>
        <Icon name="AcademicCapIcon" size={16} className="text-primary" />
      </div>
      <div className="p-4 space-y-4">
        {courses?.map(course => (
          <div key={course?.id}>
            <div className="flex items-center justify-between mb-1.5">
              <p className="text-xs font-medium text-foreground leading-snug">{course?.title}</p>
              <span className="text-[10px] font-semibold text-muted-foreground tabular-nums">{course?.completed}/{course?.total}</span>
            </div>
            <div className="w-full h-1.5 bg-muted rounded-full overflow-hidden">
              <div
                className={`h-full ${course?.color} rounded-full transition-all duration-500`}
                style={{ width: `${course?.progress}%` }}
              />
            </div>
            <p className="text-[10px] text-muted-foreground mt-1">{course?.progress}% complete</p>
          </div>
        ))}
      </div>
      <div className="px-4 pb-4">
        <button className="btn-primary w-full py-2 rounded-lg text-xs font-semibold">
          Continue Learning
        </button>
      </div>
    </div>
  );
}